import styled from "styled-components";

import { Modal } from "components/Modal";

export const ManageInvestmentsContainer = styled(Modal)`
  .modal-content {
    padding: 0px;

    .modal-body {
      padding: 0;
      margin-top: 0px;

      .heading {
        display: flex;
        align-items: center;
        width: 100%;
        text-align: center;
        color: ${({ theme }) => theme.card.font.tertiary};
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 0px;
        justify-content: center;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding: 14px;
        background-color: ${({ theme }) => theme.modal.bg.secondary};
      }

      .sub-heading {
        text-align: center;
        color: ${({ theme }) => theme.heading.color.secondary};
        font-size: 18px;
        padding: 10px;
        padding-bottom: 0px;
      }

      .title {
        font-weight: 500;
        text-align: center;
        margin-bottom: 20px;
      }

      .body-content {
        padding: 25px 30px 40px 30px;

        .box-wrapper {
          min-height: 300px;
          height: 300px;
          overflow-y: auto;
          overflow-x: hidden;
        }
      }

      .footer-wrapper {
        margin-top: 20px;

        .connect-portfolio-btn {
          text-transform: none;
        }

        button {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .loader {
            margin-right: 5px;
          }
        }
      }

      @media (max-width: 768px) {
        .heading {
          font-size: 18px;
        }

        .sub-heading {
          font-size: 16px;
        }

        .title {
          font-size: 14px;
        }

        .footer-wrapper {
          gap: 15px;
        }
      }
    }
  }

  @media (max-width: 992px) {
    .modal-lg,
    .modal-xl {
      --bs-modal-width: 90%;
    }
  }

  @media screen and (max-width: 431px) {
    .details .value {
      font-size: 20px;
    }
  }
`;

export const PortfolioBoxContainer = styled.div`
  background: ${({ theme }) => theme.statementBox.bg.primary};
  border-radius: 10px;
  border: 1px solid #e6e6e6;
  padding: 10px 16px;
  margin-bottom: 20px;
  border: 1px solid ${({ theme }) => theme.card.border.primary};

  .ml-25 {
    margin-left: -50px;
  }

  &.collapsed {
    background: ${({ theme }) => theme.aside.bg.secondary};

    .collapse {
      padding-top: 20px;
    }
  }

  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .portfolio-wrapper {
      display: flex;
      align-items: center;

      .broker-img {
        width: 27px;
        height: 27px;
        margin-right: 10px;
      }

      .broker-name {
        font-size: 15px;
        font-weight: 500;
        cursor: pointer;

        svg {
          margin-left: 10px;
        }

        .collapsed-icon {
          transform: rotate(180deg);
        }
      }
    }

    button {
      color: #ffffff;
      background-color: #ff3f3f;
      text-transform: none;

      &:hover {
        color: #ffffff;
        background-color: #ff3f3f;
      }
    }
  }

  .details {
    margin-top: 12px;

    .label {
      color: ${({ theme }) => theme.card.font.secondary};
      font-size: 14px;
      font-weight: 500;
      line-height: normal;
      padding-bottom: 5px;
    }

    .value {
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.global.form.primary};
      font-size: 25px;
      font-style: normal;
      font-weight: 400;
    }

    .min-value {
      padding-top: 3px;
      color: ${({ theme }) => theme.card.font.secondary};
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0.5px;
    }

    .amount {
      display: flex;
      align-items: center;
      padding-left: 12px;

      .allocation-input-wrapper {
        display: flex;
        align-items: center;

        .negative-margin {
          margin-right: -22px;
          z-index: 1;
        }

        .allocation-price-input {
          margin-right: 10px;
          font-size: 14px;
          padding: 10px 15px 10px 28px;
          min-width: 110px;
          max-width: 110px;
          border: none;
          height: 41px;
          background: ${({ theme }) => theme.input.bg.tertiary};
          border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_25};
          border: 1px solid ${({ theme }) => theme.input.border.color};
          color: ${({ theme }) => theme.input.font.primary};

          &:focus {
            box-shadow: none;
            outline: none;
          }

          &:disabled {
            cursor: not-allowed;
          }
        }
      }
    }

    .error-message {
      color: ${({ theme }) => theme.modal.error.font.color};
      font-size: 12px;
      font-weight: 400;
      margin-left: 0px;
      display: block;
      width: 100%;
    }

    .percentage {
      font-size: 15px;
      font-weight: 400;
      width: 50px;
    }
  }

  .stale-wrapper {
    margin-top: 20px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    .label {
      font-size: 20px;
      font-weight: 500;
    }

    button {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .header {
      flex-direction: column;
      gap: 10px;
    }

    .details {
      .spacing {
        padding-top: 5px !important;
        padding-bottom: 10px !important;
      }

      .value {
        font-size: 20px;
      }
    }

    button {
      height: 36px;
    }
  }
`;
